<template>
  <div id="lost">
    <div class="vx-card p-1" style="height:30rem;">
      <div class="flex flex-wrap items-center mb-base" style="padding: 0.25rem;">
        <div class="flex-grow">
          <div class="top-area">
            <div class="category-name aisea-text-14-400-black">ロスト</div>
            <vs-icon
              class="edit-button"
              icon-pack="feather"
              icon="icon-edit"
              type="border"
              @click="showDialogLostEdit"
            >
            </vs-icon>
          </div>
          <div class="lost-tanks">
            <div class="lost-tank">
              <vs-row style="width:4rem;height:25rem;">
                <vs-col
                  v-for="(data, index) in tankData"
                  :key="index"
                  class="tank-col flex justify-center items-center"
                  style="width:4rem;height:10rem;margin-bottom:4.5rem"
                >
                  <tank-name
                    class="name aisea-text-14-400-black"
                    :name="data.name"
                  ></tank-name>
                  <tank-gauge
                    :background="AISEA_COLOR.RED"
                    :percentage="data.percentage"
                    :upperLimit="data.upperLimit"
                    :lowerLimit="data.lowerLimit"
                  ></tank-gauge>
                  <tank-info
                    class="aisea-text-14-400-black"
                    :level="data.vn"
                    :tonn="data.vs"
                  ></tank-info>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dialog-lost-edit ref="dialogLostEdit" :vesselId="vesselId" :editCondition="tankData"></dialog-lost-edit>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import TankGauge from "./TankGauge.vue";
import TankInfo from "./TankInfo.vue";
import TankName from "./TankName.vue";
import DialogLostEdit from "./DialogLostEdit.vue";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("ecoShip");
import { ColorMixin } from "@/mixins";

export default {
  components: {
    TankName,
    TankGauge,
    TankInfo,
    DialogLostEdit
  },
  mixins: [ColorMixin],
  props: {
    vesselId: { type: String },
    data: { type: Object },
  },
  data() {
    return {
      version: {},
      tankData: [],
      dialogInfo: null,
    };
  },
  watch: {
    levelGaugeLastUpdatedAt() {
      this.setTankData(this.tankData);
    }
  },
  created() {
    this.getChannels();
  },
  computed: {
    ...mapState({
      versionName: state => state.kind.level_gauge.versionName,
      levelGauge: state => state.levelGauge,
      levelGaugeDashboard: state => state.levelGaugeDashboard,
      lostData: state => state.lostData,
      levelGaugeLastUpdatedAt: state => state.levelGaugeLastUpdatedAt
    })
  },
  methods: {
    ...mapActions([
      "fetchLevelGaugeDashboard",
      "unsubscribeFirestore"
    ]),
    async getChannels() {
      let payload = {
        enterprise_id: this.$store.state.auth.user.id,
        vessel_id: this.vesselId,
        name: this.versionName
      }
      let dashboard = await this.fetchLevelGaugeDashboard(payload);

      let dashboardList = dashboard["lostList"].data;

      let tankData = [];
      dashboardList.forEach(d => {
        tankData.push({
          name: d.label,
          vn: null,
          vs: null,
          percentage: null,
          upperLimit: null,
          lowerLimit: null,
          maxId: d.max.channel_id,
          // valueId: d.kg.channel_id,
          upperLimitId: d.upper_limit.channel_id,
          lowerLimitId: d.lower_limit.channel_id,
          // weightId: d.weight.channel_id,
        });
      });

      this.tankData = tankData;

      this.setTankData(tankData);
    },

    setTankData(tankData) {
      // TODO 現状のロストはメモ書きレベルなので暫定的な実装。今後変更になる可能性あり。
      tankData.forEach(m => {
        this.data[this.vesselId].forEach(e => {
          // let max = null;
          // if (m.maxId in e) {
          //   max = e[m.maxId].vn
          // }
          if (m.name === e.label) {
            let vn = e.kg.value / 100;
            let vs = e.weight.value / 100;
            m.vn = vn.toFixed(2);
            m.vs = vs.toFixed(1);
          }
          // if (m.upperLimitId in e) {
          //   m.upperLimit = e[m.upperLimitId].vn / max;
          // }
          // if (m.lowerLimitId in e) {
          //   m.lowerLimit = e[m.lowerLimitId].vn / max;
          // }
          // if (m.weightId in e) {
          //   const vn = e[m.weightId].vn / 100;
          //   m.vs = vn.toFixed(2);
          // }
        });
      });
    },
    showDialogLostEdit() {
      this.$refs.dialogLostEdit.show();
    }
  },
  beforeDestroy() {
    this.unsubscribeFirestore();
  }
};
</script>

<style lang="scss">
#lost {
  .vx-card {
    box-shadow: 0px 2px 10px 0px rgba(0,0,0,.1);
  }
  .top-area {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 5px;
    padding-bottom: 10px;
  }
  .edit-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: #00c1fc;
    margin-left: 15%;
  }
  .category-name {
    width: 60%;
    align-items: center;
    margin-left: 5%;
  }
  .lost-tanks {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    padding: 5px 10px;
    text-align: center;
  }
  .lost-tank {
    padding: 3px;
  }
  .tank-col {
    flex-direction: column;
  }
  .name {
    padding-top: 10px;
  }
}
</style>
